import type { LintingResponseType } from '@readme/api/src/routes/pages/guides/operations/lintGuide';

export function isStyleguideResults(results): results is LintingResponseType['data']['styleguide'] {
  return Array.isArray(results) && 'score' in results[0];
}
